export enum TabLabelEnum {
  CompanyAndBilling = 'Company & Billing',
  PaidSearchIntegration = 'Paid Search Integrations',
  ManageUsers = 'Manage Users',
}
